import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { ENABLE_MODAL_SWIPE_BACK } from '../utils/mobileModalSwipe';
import AppUsageBoard from './AppUsageBoard';
import '../styles/newDesign.css';

export default function AppUsageMobile({ open, onClose }) {
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const [isMobileDevice, setIsMobileDevice] = useState(() => (
    window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  ));

  useEffect(() => {
    const handleResize = () => {
      setIsMobileDevice(window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!ENABLE_MODAL_SWIPE_BACK) {
      touchStartX.current = null;
      touchEndX.current = null;
      return;
    }
    if (!touchStartX.current || !touchEndX.current) return;
    const distance = touchStartX.current - touchEndX.current;
    if (distance > 50) onClose?.();
    touchStartX.current = null;
    touchEndX.current = null;
  };

  if (!open || !isMobileDevice) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 100004,
        display: 'flex',
        background: 'rgba(4, 10, 13, 0.88)',
      }}
      {...(ENABLE_MODAL_SWIPE_BACK
        ? { onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd }
        : {})}
    >
      <AppUsageBoard isMobile onClose={onClose} />
    </div>,
    document.body
  );
}
